exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-selector[data-v-327458d7] {\n  width: 20px;\n  height: 20px;\n}\n.price-selector:hover .square[data-v-327458d7] {\n  background-color: #C4C4C4;\n}\n.price-selector.active .square[data-v-327458d7] {\n  background-color: #707070;\n}\n.square[data-v-327458d7] {\n  width: 80%;\n  height: 80%;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", ""]);

// exports
